import $ from 'jquery';
import 'jquery.mmenu';
$(document).ready(function( $ ){
  $('#wow-mobile-menu').mmenu({
    scrollBugFix: {
      fix: false
    }
  });
});


// WEBPACK FOOTER //
// ./resources/templates/changply/assets/js/components/mobile-menu.js